import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
//  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button, 
  LinearProgress,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const AgencyTable = props => {
  const { 
    className, 
    userRole,
    agencies, 
    onSetSelectedAgencies,
    onClickOpenRegister,
    onClickOpenEdit,
    onClickOpenDelete,
    disableEditButton,
    disableDeleteButton,

    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,
    
    ...rest } = props;

  const classes = useStyles();

  const [selectedAgencies, setSelectedAgencies] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedAgencies;

    if (event.target.checked) {
      selectedAgencies = agencies.filter(agency => {
        if (agency.have_clients) {
          return false;
        }
        return true;
      });
      selectedAgencies = selectedAgencies.map(agency => agency.id);
      //selectedAgencies = agencies.map(agency => agency.id);
    } else {
      selectedAgencies = [];
    }

    setSelectedAgencies(selectedAgencies);
    onSetSelectedAgencies(selectedAgencies);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedAgencies.indexOf(id);
    let newSelectedAgencies = [];

    if (selectedIndex === -1) {
      newSelectedAgencies = newSelectedAgencies.concat(selectedAgencies, id);
    } else if (selectedIndex === 0) {
      newSelectedAgencies = newSelectedAgencies.concat(selectedAgencies.slice(1));
    } else if (selectedIndex === selectedAgencies.length - 1) {
      newSelectedAgencies = newSelectedAgencies.concat(selectedAgencies.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedAgencies = newSelectedAgencies.concat(
        selectedAgencies.slice(0, selectedIndex),
        selectedAgencies.slice(selectedIndex + 1)
      );
    }

    setSelectedAgencies(newSelectedAgencies);
    onSetSelectedAgencies(newSelectedAgencies);
  };

  // const handlePageChange = (event, page) => {
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(event.target.value);
  // };


  // const [openAlert, setOpenAlert] = useState(false);

  // const handleClickOpenAlert = () => {
  //   setOpenAlert(true);
  // };

  // const handleCloseAlert = () => {
  //   setOpenAlert(false);
  // };


  useEffect(() => {
    //console.log('componentDidUpdate & agencies changed -> ' + agencies.length);

    const newSelected = selectedAgencies.filter(id => {
      const findObj = agencies.find(obj => obj.id == id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedAgencies(newSelected);
    onSetSelectedAgencies(newSelected);

  }, [agencies]);

  return (
    <div>

      {userRole !== 'user' && (
        <div className={classes.row}>
          <Button
            color="primary"
            variant="contained"
            onClick={ onClickOpenRegister }
          >
            등록
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ disableEditButton }
            onClick={ onClickOpenEdit }
          >
            수정
          </Button>

          <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
            variant="contained"
            disabled={ disableDeleteButton }
            onClick={ onClickOpenDelete }
          >
            삭제
          </Button>

        </div>
      )}

      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {openProgress && <LinearProgress /> }
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={agencies.length > 0 && selectedAgencies.length === agencies.length}
                        color="primary"
                        indeterminate={
                          selectedAgencies.length > 0 &&
                          selectedAgencies.length < agencies.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>번호</TableCell>
                    <TableCell>광고대행사명</TableCell>
                    <TableCell>거래담당자</TableCell>
                    <TableCell>전화번호</TableCell>
                    <TableCell>등록일</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {agencies.map((agency, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={agency.id}
                      selected={selectedAgencies.indexOf(agency.id) !== -1}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedAgencies.indexOf(agency.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, agency.id)}
                          value="true"
                          disabled={agency.have_clients}
                        />
                      </TableCell>
                      <TableCell>{index}</TableCell>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          {/* <Avatar
                            className={classes.avatar}
                            src={category.avatarUrl}
                          >
                            {getInitials(category.name)}
                          </Avatar> */}
                          <Typography variant="body1">{agency.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{agency.manager}</TableCell>
                      <TableCell>{agency.tel}</TableCell>
                      <TableCell>
                        {moment(agency.reg_at).format('YYYY-MM-DD')}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            labelRowsPerPage=''
            component="div"
            count={item_total}
            onChangePage={onPageChange}
            onChangeRowsPerPage={onRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>

    </div>
  );
};

AgencyTable.propTypes = {
  className: PropTypes.string,
  agencies: PropTypes.array.isRequired
};


AgencyTable.defaultProps = {
  agencies: [],
};


export default AgencyTable;
